import {inject} from '@angular/core';
import {ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot} from '@angular/router';
import {DepartmentService, OrganizationService} from '../../apiModule1';

export const departmentResolver: ResolveFn<any> = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
  service: DepartmentService = inject(DepartmentService)) => {
  return service.apiDepartmentGet({}, 'body', false, {transferCache: false});
};
